exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* defaults */\n.btn {\n  display: block;\n  margin-bottom: 15px;\n}\n\n.wrap-block-animation {\n  border: 1px solid #ccc;\n  width: 100%;\n  height: 200px;\n  position: relative;\n}\n.element-block-animated {\n  width: 25%;\n  height: 50%;\n  background: #900;\n  position: absolute;\n  /* transform: translate3d(300%, 100%, 0); */\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/XAMPP/xamppfiles/htdocs/estudos/angular2/animation-course/basic-project/src/app/loop-demo/loop-demo.component.css
// module id = ../../../../../src/app/loop-demo/loop-demo.component.css
// module chunks = main